import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createConfirmOtpValidationSchema = Yup.object().shape({
  otp: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  password: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  confirmPassword: Yup.string()
    .required(SystemMessage.CONFIRM_PASSWORD_REQUIRED)
    .oneOf([Yup.ref("password")], SystemMessage.CONFIRM_PASSWORD_INVALID),
});
